export default "__VITE_ASSET__52113200__"